/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelist_TitleInputs */

const id_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar Perubahan`)
};

const ms_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senarai Perubahan`)
};

const da_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringsliste`)
};

const de_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsliste`)
};

const en_us2_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelist`)
};

const es_es2_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de cambios`)
};

const es_mx2_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de cambios`)
};

const fil_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listahan ng Pagbabago`)
};

const fr_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des modifications`)
};

const it_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco modifiche`)
};

const hu_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változtatási lista`)
};

const nl_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingslijst`)
};

const no_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringsliste`)
};

const pl_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista zmian`)
};

const pt_br2_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelist`)
};

const pt_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de alterações`)
};

const ro_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listă modificări`)
};

const fi_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutoslista`)
};

const sv_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringslista`)
};

const vi_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách thay đổi`)
};

const tr_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik Listesi`)
};

const cs_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam změn`)
};

const bg_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Списък на промените`)
};

const ru_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список изменений`)
};

const uk_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список змін`)
};

const ar_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة التغييرات`)
};

const hi_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन सूची`)
};

const th_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการเปลี่ยนแปลง`)
};

const ja_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更リスト`)
};

const zh_cn2_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelist`)
};

const zh_hant1_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelist`)
};

const ko_components_changelist_title = /** @type {(inputs: Components_Changelist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelist`)
};

/**
* | output |
* | --- |
* | "Changelist" |
*
* @param {Components_Changelist_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelist_title = /** @type {((inputs?: Components_Changelist_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelist_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelist_title(inputs)
	if (locale === "ms") return ms_components_changelist_title(inputs)
	if (locale === "da") return da_components_changelist_title(inputs)
	if (locale === "de") return de_components_changelist_title(inputs)
	if (locale === "en-US") return en_us2_components_changelist_title(inputs)
	if (locale === "es-ES") return es_es2_components_changelist_title(inputs)
	if (locale === "es-MX") return es_mx2_components_changelist_title(inputs)
	if (locale === "fil") return fil_components_changelist_title(inputs)
	if (locale === "fr") return fr_components_changelist_title(inputs)
	if (locale === "it") return it_components_changelist_title(inputs)
	if (locale === "hu") return hu_components_changelist_title(inputs)
	if (locale === "nl") return nl_components_changelist_title(inputs)
	if (locale === "no") return no_components_changelist_title(inputs)
	if (locale === "pl") return pl_components_changelist_title(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelist_title(inputs)
	if (locale === "pt") return pt_components_changelist_title(inputs)
	if (locale === "ro") return ro_components_changelist_title(inputs)
	if (locale === "fi") return fi_components_changelist_title(inputs)
	if (locale === "sv") return sv_components_changelist_title(inputs)
	if (locale === "vi") return vi_components_changelist_title(inputs)
	if (locale === "tr") return tr_components_changelist_title(inputs)
	if (locale === "cs") return cs_components_changelist_title(inputs)
	if (locale === "bg") return bg_components_changelist_title(inputs)
	if (locale === "ru") return ru_components_changelist_title(inputs)
	if (locale === "uk") return uk_components_changelist_title(inputs)
	if (locale === "ar") return ar_components_changelist_title(inputs)
	if (locale === "hi") return hi_components_changelist_title(inputs)
	if (locale === "th") return th_components_changelist_title(inputs)
	if (locale === "ja") return ja_components_changelist_title(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelist_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelist_title(inputs)
	return ko_components_changelist_title(inputs)
});
export { components_changelist_title as "components.changelist.title" }